//
//
//
//
//
//
//
//
//

import $manager from "@/Manager/049.SmartGms/MemberLabelManager.js";
import PageDetail from "@/0/components/0.comPage/04.comPageDetail.vue";
export default {
  components: {
    "page-detail": PageDetail,
  },
  data() {
    return {
      dataConfig: {

      },
      footerConfig: {
        ButtonList: [
          
        ]
      },

    };
  },
  
  methods:{

    getManager(){
      return $manager;
    },

  }
};
